import { axiosInstance } from 'network/apis';

export const fetchInterviewPaymentStatuses = async () => {
  return await axiosInstance.get('MyProxy/interview-payment-status-list', { handlerEnabled: true });
};

export default {
  fetchInterviewPaymentStatuses
}